import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { motion } from "framer-motion";
import React, { useContext, useEffect, useState } from "react";
import { BsAndroid2 } from "react-icons/bs";
import { FaDatabase, FaDesktop, FaGithub } from "react-icons/fa";
import { GrTextAlignFull } from "react-icons/gr";
import { RiScreenshot2Fill } from "react-icons/ri";
import VisibilitySensor from "react-visibility-sensor";
import { Context } from "../../context";
import classes from "./Demo.module.css";
import DemoGallery from "./DemoGallery";
const url = "https://demo-api.davidebalice.dev/api/demo/";

const DemoCard = ({
  _id,
  title,
  subtitle,
  slug,
  delay,
  description,
  tecnology,
  frontend,
  backend,
  github,
  githubBackend,
  apk,
  imageCover,
  fullstack,
  card,
  selectedCard,
  openPopupCard,
  handleCloseCard,
  colClass = "col-md-6 my-1",
}) => {
  const parse = require("html-react-parser");
  const { debug, lang } = useContext(Context);
  const [gallery, setGallery] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedTab, setSelectedTab] = useState("description");

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const arrayTech = tecnology.split(",");

  const getData = async () => {
    try {
      const response = await axios.get(url + slug);
      setGallery(response.data.demo);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (selectedTab === "gallery") {
      getData();
    }
  }, [slug, selectedTab]);

  return (
    <div className={colClass}>
      <motion.div
        layout
        drag={selectedCard === card ? "x" : false}
        dragConstraints={{ left: 0, right: 0 }}
        dragElastic={0.2}
        className={
          selectedCard === card
            ? classes.openedCardContainer
            : classes.cardWrapper
        }
        initial={{
          opacity: 0,
          delay: 0.1,
          y: -50,
        }}
        animate={{
          y: 0,
          opacity: 1,
          delay: 0.1,
        }}
        transition={{
          duration: 0.4,
          y: { duration: 0.6, delay: delay },
          opacity: { duration: 0.5, delay: delay },
        }}
      >
        <VisibilitySensor
          onChange={changeVisibility}
          partialVisibility
          delayedCall
        >
          <motion.div
            animate={{
              opacity: isVisible ? 1 : 0,
              delay: 0.2,
            }}
            transition={{ duration: 0.3, delay: delay }}
            key={"democard" + _id}
            style={{ position: "relative", overflow: "hidden" }}
            className={selectedCard === card ? classes.openedCard : ""}
          >
            <div className={classes.demoTech}>
              {arrayTech.map((val, index) => (
                <div key={"demoicon" + Math.random() + _id}>
                  {val === "Next.js" ? (
                    <img
                      className={classes.demoTechImg}
                      src={"/assets/images/demos/Nextjs_icon.jpg"}
                      alt=""
                    />
                  ) : (
                    <img
                      className={classes.demoTechImg}
                      src={"/assets/images/demos/" + val.trim() + "_icon.jpg"}
                      alt=""
                    />
                  )}
                </div>
              ))}
            </div>
            {selectedCard === card && (
              <button
                className={classes.buttonClose}
                onClick={(e) => {
                  handleCloseCard(card);
                }}
              >
                X
              </button>
            )}

            <div
              className="demo-box mb-3"
              style={{ width: selectedCard === card ? "100% !important" : "" }}
            >
              {fullstack && selectedCard !== card && (
                <div className={classes.fsBand}>
                  <FontAwesomeIcon icon={faLayerGroup} />
                  <span>Full stack</span>
                </div>
              )}

              <div
                className="demo-img"
                style={{
                  width: selectedCard === card ? "100% !important" : "",
                }}
              >
                <div
                  className={
                    selectedCard === card
                      ? classes.demoCardOpened
                      : classes.demoCard
                  }
                  style={{
                    background: `url("https://demo-api.davidebalice.dev/api/demo/cover/${imageCover}")`,
                  }}
                >
                  <div className="title-overlay">
                    <div className="title-overlay-details">
                      <div
                        href="elements.html"
                        target="_blank"
                        className={
                          selectedCard === card
                            ? classes.cardTitleOpened
                            : classes.cardTitle
                        }
                      >
                        {title}
                      </div>
                    </div>
                  </div>

                  {selectedCard !== card && (
                    <div className="demo-overlay">
                      <div>
                        {/*
                     <NavLink
                      to={`/demo/${slug}`}
                      className="nav-link smooth-scroll btn-demo-link"
                    >
                    */}
                        <div
                          onClick={(e, info) => openPopupCard(e, info, card)}
                          className="nav-link smooth-scroll btn-demo-link"
                        >
                          <span className="btn btn-outline-light btn-sm bg-white black btn-demo">
                            {lang === "en" && <>Demo details</>}
                            {lang === "it" && <>Dettaglio demo</>}
                          </span>
                        </div>
                      </div>

                      {frontend && (
                        <div>
                          <a
                            href={frontend}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-demo-link"
                          >
                            <span className="btn btn-outline-light btn-sm btn-demo btn-demo-frontend">
                              <FaDesktop className={`btn-demo-icon`} />
                              <span>frontend</span>
                            </span>
                          </a>
                        </div>
                      )}

                      {backend && (
                        <div>
                          <a
                            href={backend}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-demo-link"
                          >
                            <span className="btn btn-outline-light btn-sm btn-demo btn-demo-backend">
                              <FaDatabase className={`btn-demo-icon`} />
                              <span>backend</span>
                            </span>
                          </a>
                        </div>
                      )}

                      {github && !githubBackend && (
                        <div>
                          <a
                            href={github}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-demo-link"
                          >
                            <span className="btn btn-outline-light btn-sm btn-demo btn-demo-github">
                              <FaGithub className={`btn-demo-icon`} />
                              <span>github</span>
                            </span>
                          </a>
                        </div>
                      )}

                      {github && githubBackend && (
                        <>
                          <div style={{ display: "flex", gap: "6px" }}>
                            <div style={{ width: "110px" }}>
                              <a
                                href={github}
                                target="_blank"
                                rel="noreferrer"
                                className="btn-demo-link"
                                style={{ width: "110px" }}
                              >
                                <span
                                  className="btn btn-outline-light btn-sm btn-demo btn-demo-github"
                                  style={{ width: "120px" }}
                                >
                                  <FaGithub className={`btn-demo-icon`} />
                                  <span>frontend</span>
                                </span>
                              </a>
                            </div>
                            <div style={{ width: "110px" }}>
                              <a
                                href={githubBackend}
                                target="_blank"
                                rel="noreferrer"
                                className="btn-demo-link"
                                style={{ width: "110px" }}
                              >
                                <span
                                  className="btn btn-outline-light btn-sm btn-demo btn-demo-github"
                                  style={{ width: "120px" }}
                                >
                                  <FaGithub className={`btn-demo-icon`} />
                                  <span>backend</span>
                                </span>
                              </a>
                            </div>
                          </div>
                        </>
                      )}

                      {apk && (
                        <div>
                          <a
                            href={`https://www.aroundweb.it/apk/${apk}`}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-demo-link"
                          >
                            <span className="btn btn-outline-light btn-sm btn-demo btn-demo-apk">
                              <BsAndroid2 className={`btn-demo-icon`} />
                              <span>apk</span>
                            </span>
                          </a>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {selectedCard === card && (
                <>
                  <div className={classes.tabContainer}>
                    <div
                      className={`${classes.tabItem} ${classes.tabFirstItem} ${
                        selectedTab === "description" ? classes.tabSelected : ""
                      }`}
                      onClick={() => setSelectedTab("description")}
                    >
                      <GrTextAlignFull size={18} />
                      Description
                    </div>
                    <div
                      onClick={() => setSelectedTab("gallery")}
                      className={`${classes.tabItem} ${
                        selectedTab === "gallery" ? classes.tabSelected : ""
                      }`}
                    >
                      <RiScreenshot2Fill size={24} />
                      Screenshot
                    </div>
                  </div>
                  <div className={classes.demoContent}>
                    <div className={classes.demoTextContainer}>
                      <div className={classes.cardSide2}>
                        {frontend && (
                          <motion.div
                            initial={{
                              opacity: 0,
                              delay: 0.1,
                              y: -10,
                            }}
                            animate={{
                              y: 0,
                              opacity: 1,
                              delay: 0.5,
                            }}
                            transition={{
                              duration: 0.3,
                              y: { duration: 0.5, delay: 0.25 },
                              opacity: { duration: 0.5, delay: 0.25 },
                            }}
                          >
                            <a
                              href={frontend}
                              target="_blank"
                              rel="noreferrer"
                              className="btn-demo-link"
                            >
                              <span className="btn btn-outline-light btn-sm btn-demo btn-demo-frontend">
                                <FaDesktop className={`btn-demo-icon`} />
                                <span>frontend</span>
                              </span>
                            </a>
                          </motion.div>
                        )}

                        {backend && (
                          <motion.div
                            initial={{
                              opacity: 0,
                              delay: 0.1,
                              y: -10,
                            }}
                            animate={{
                              y: 0,
                              opacity: 1,
                              delay: 0.5,
                            }}
                            transition={{
                              duration: 0.3,
                              y: { duration: 0.5, delay: 0.5 },
                              opacity: { duration: 0.5, delay: 0.5 },
                            }}
                          >
                            <a
                              href={backend}
                              target="_blank"
                              rel="noreferrer"
                              className="btn-demo-link"
                            >
                              <span className="btn btn-outline-light btn-sm btn-demo btn-demo-backend">
                                <FaDatabase className={`btn-demo-icon`} />
                                <span>backend</span>
                              </span>
                            </a>
                          </motion.div>
                        )}

                        {github && (
                          <motion.div
                            initial={{
                              opacity: 0,
                              delay: 0.1,
                              y: -10,
                            }}
                            animate={{
                              y: 0,
                              opacity: 1,
                              delay: 0.5,
                            }}
                            transition={{
                              duration: 0.3,
                              y: { duration: 0.5, delay: 0.75 },
                              opacity: { duration: 0.5, delay: 0.75 },
                            }}
                          >
                            <a
                              href={github}
                              target="_blank"
                              rel="noreferrer"
                              className="btn-demo-link"
                            >
                              <span className="btn btn-outline-light btn-sm btn-demo btn-demo-github">
                                <FaGithub className={`btn-demo-icon`} />
                                <span>github</span>
                              </span>
                            </a>
                          </motion.div>
                        )}

                        {githubBackend && (
                          <motion.div
                            initial={{
                              opacity: 0,
                              delay: 0.1,
                              y: -10,
                            }}
                            animate={{
                              y: 0,
                              opacity: 1,
                              delay: 0.3,
                            }}
                            transition={{
                              duration: 0.4,
                              y: { duration: 0.5, delay: 1 },
                              opacity: { duration: 0.5, delay: 1 },
                            }}
                          >
                            <a
                              href={githubBackend}
                              target="_blank"
                              rel="noreferrer"
                              className="btn-demo-link"
                            >
                              <span className="btn btn-outline-light btn-sm btn-demo btn-demo-github">
                                <FaGithub className={`btn-demo-icon`} />
                                <span>backend</span>
                              </span>
                            </a>
                          </motion.div>
                        )}

                        {apk && (
                          <motion.div
                            initial={{
                              opacity: 0,
                              delay: 0.1,
                              y: -10,
                            }}
                            animate={{
                              y: 0,
                              opacity: 1,
                              delay: 0.5,
                            }}
                            transition={{
                              duration: 0.3,
                              y: { duration: 0.5, delay: 0.75 },
                              opacity: { duration: 0.5, delay: 0.75 },
                            }}
                          >
                            <a
                              href={`https://www.aroundweb.it/apk/${apk}`}
                              target="_blank"
                              rel="noreferrer"
                              className="btn-demo-link"
                            >
                              <span className="btn btn-outline-light btn-sm btn-demo btn-demo-apk">
                                <BsAndroid2 className={`btn-demo-icon`} />
                                <span>apk</span>
                              </span>
                            </a>
                          </motion.div>
                        )}
                      </div>

                      {selectedTab === "description" && (
                        <motion.div
                          initial={{
                            opacity: 0,
                            delay: 0.1,
                            y: -10,
                          }}
                          animate={{
                            y: 0,
                            opacity: 1,
                            delay: 0.3,
                          }}
                          transition={{
                            duration: 0.4,
                            y: { duration: 0.5, delay: 0.25 },
                            opacity: { duration: 0.5, delay: 0.25 },
                          }}
                        >
                          <h5>{title}</h5>
                          <h6>{subtitle}</h6>
                          <br />
                          Tecnology: {tecnology}
                          <br />
                          <br />
                          {parse(description.replace(/\n/g, "<br />"))}
                          <br />
                          <br />
                        </motion.div>
                      )}

                      {selectedTab === "gallery" && (
                        <motion.div
                          initial={{
                            opacity: 0,
                            delay: 0.1,
                            y: -10,
                          }}
                          animate={{
                            y: 0,
                            opacity: 1,
                            delay: 0.3,
                          }}
                          transition={{
                            duration: 0.4,
                            y: { duration: 0.5, delay: 0.25 },
                            opacity: { duration: 0.5, delay: 0.25 },
                          }}
                        >
                          <DemoGallery slug={slug} selectedTab={selectedTab} />
                        </motion.div>
                      )}
                    </div>

                    <div className={classes.cardSide}>
                      {frontend && (
                        <motion.div
                          initial={{
                            opacity: 0,
                            delay: 0.1,
                            y: -10,
                          }}
                          animate={{
                            y: 0,
                            opacity: 1,
                            delay: 0.5,
                          }}
                          transition={{
                            duration: 0.3,
                            y: { duration: 0.5, delay: 0.25 },
                            opacity: { duration: 0.5, delay: 0.25 },
                          }}
                        >
                          <a
                            href={frontend}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-demo-link"
                          >
                            <span className="btn btn-outline-light btn-sm btn-demo btn-demo-frontend">
                              <FaDesktop className={`btn-demo-icon`} />
                              <span>frontend</span>
                            </span>
                          </a>
                        </motion.div>
                      )}

                      {backend && (
                        <motion.div
                          initial={{
                            opacity: 0,
                            delay: 0.1,
                            y: -10,
                          }}
                          animate={{
                            y: 0,
                            opacity: 1,
                            delay: 0.5,
                          }}
                          transition={{
                            duration: 0.3,
                            y: { duration: 0.5, delay: 0.5 },
                            opacity: { duration: 0.5, delay: 0.5 },
                          }}
                        >
                          <a
                            href={backend}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-demo-link"
                          >
                            <span className="btn btn-outline-light btn-sm btn-demo btn-demo-backend">
                              <FaDatabase className={`btn-demo-icon`} />
                              <span>backend</span>
                            </span>
                          </a>
                        </motion.div>
                      )}

                      {github && (
                        <motion.div
                          initial={{
                            opacity: 0,
                            delay: 0.1,
                            y: -10,
                          }}
                          animate={{
                            y: 0,
                            opacity: 1,
                            delay: 0.5,
                          }}
                          transition={{
                            duration: 0.3,
                            y: { duration: 0.5, delay: 0.75 },
                            opacity: { duration: 0.5, delay: 0.75 },
                          }}
                        >
                          <a
                            href={github}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-demo-link"
                          >
                            <span className="btn btn-outline-light btn-sm btn-demo btn-demo-github">
                              <FaGithub className={`btn-demo-icon`} />
                              <span>github</span>
                            </span>
                          </a>
                        </motion.div>
                      )}

                      {githubBackend && (
                        <motion.div
                          initial={{
                            opacity: 0,
                            delay: 0.1,
                            y: -10,
                          }}
                          animate={{
                            y: 0,
                            opacity: 1,
                            delay: 0.3,
                          }}
                          transition={{
                            duration: 0.4,
                            y: { duration: 0.5, delay: 1 },
                            opacity: { duration: 0.5, delay: 1 },
                          }}
                        >
                          <a
                            href={githubBackend}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-demo-link"
                          >
                            <span className="btn btn-outline-light btn-sm btn-demo btn-demo-github">
                              <FaGithub className={`btn-demo-icon`} />
                              <span>backend</span>
                            </span>
                          </a>
                        </motion.div>
                      )}

                      {apk && (
                        <motion.div
                          initial={{
                            opacity: 0,
                            delay: 0.1,
                            y: -10,
                          }}
                          animate={{
                            y: 0,
                            opacity: 1,
                            delay: 0.5,
                          }}
                          transition={{
                            duration: 0.3,
                            y: { duration: 0.5, delay: 0.75 },
                            opacity: { duration: 0.5, delay: 0.75 },
                          }}
                        >
                          <a
                            href={`https://www.aroundweb.it/apk/${apk}`}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-demo-link"
                          >
                            <span className="btn btn-outline-light btn-sm btn-demo btn-demo-apk">
                              <BsAndroid2 className={`btn-demo-icon`} />
                              <span>apk</span>
                            </span>
                          </a>
                        </motion.div>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="btn-demo-mobile">
                <div className="btn-demo-mobile-item">
                  <div
                    onClick={(e, info) => openPopupCard(e, info, card)}
                    className="nav-link smooth-scroll btn-demo-link"
                  >
                    <span className="btn btn-outline-light btn-sm bg-white black btn-demo">
                      {lang === "en" && <>Details</>}
                      {lang === "it" && <>Dettaglio</>}
                    </span>
                  </div>
                </div>

                {frontend && (
                 <div className="btn-demo-mobile-item">
                    <a
                      href={frontend}
                      target="_blank"
                      rel="noreferrer"
                      className="btn-demo-link"
                    >
                      <span className="btn btn-outline-light btn-sm btn-demo btn-demo-frontend">
                        <FaDesktop className={`btn-demo-icon`} />

                        <span>frontend</span>
                      </span>
                    </a>
                  </div>
                )}

                {backend && (
                  <div className="btn-demo-mobile-item">
                    <a
                      href={backend}
                      target="_blank"
                      rel="noreferrer"
                      className="btn-demo-link"
                    >
                      <span className="btn btn-outline-light btn-sm btn-demo btn-demo-backend">
                        <FaDatabase className={`btn-demo-icon`} />
                        <span>backend</span>
                      </span>
                    </a>
                  </div>
                )}

                {github && (
                  <div className="btn-demo-mobile-item">
                    <a
                      href={github}
                      target="_blank"
                      rel="noreferrer"
                      className="btn-demo-link"
                    >
                      <span className="btn btn-outline-light btn-sm btn-demo btn-demo-github">
                        <FaGithub className={`btn-demo-icon`} />
                        <span>github</span>
                      </span>
                    </a>
                  </div>
                )}

                {githubBackend && (
                  <div className="btn-demo-mobile-item">
                    <a
                      href={githubBackend}
                      target="_blank"
                      rel="noreferrer"
                      className="btn-demo-link"
                    >
                      <span className="btn btn-outline-light btn-sm btn-demo btn-demo-github">
                        <FaGithub className={`btn-demo-icon`} />
                        <span>backend</span>
                      </span>
                    </a>
                  </div>
                )}

                {apk && (
                  <div className="btn-demo-mobile-item">
                    <a
                      href={`https://www.aroundweb.it/apk/${apk}`}
                      target="_blank"
                      rel="noreferrer"
                      className="btn-demo-link"
                    >
                      <span className="btn btn-outline-light btn-sm btn-demo btn-demo-apk">
                        <BsAndroid2 className={`btn-demo-icon`} />
                        <span>apk</span>
                      </span>
                    </a>
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        </VisibilitySensor>
      </motion.div>
    </div>
  );
};

export default DemoCard;
